import React from 'react';

const SmallDataCard  = (props) => {
    return (
<div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
    <div className="card">
        <div className="card-header p-3 pt-2">
            <div className={"icon icon-lg icon-shape bg-gradient-"+props.color+" shadow-"+props.color+" text-center border-radius-xl mt-n4 position-absolute"}>
            <i className="material-icons opacity-10">{ props.icon }</i>
            </div>
            <div className="text-end pt-1">
            <p className="text-sm mb-0 text-capitalize">{ props.measure }</p>
            <h4 className="mb-0"> { props.savings } { props.units }</h4>
            </div>
        </div>
        <hr className="dark horizontal my-0" />
        <div className="card-footer p-3">
            <p className="mb-0"><span className="text-success text-sm font-weight-bolder">+ { props.footersavings } </span>{ props.since }</p>
        </div>
    </div>  
</div>
    )
}

export default SmallDataCard;